import DateTime from 'react-datetime';
import * as React from 'react';
import Select from 'react-select';
import { Row, Col, FormGroup, ControlLabel, Checkbox, Button } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import { ISelectViewModel } from '../Types';
import moment from 'moment';

interface IProps {
    fromDate: any;
    onFromDateChange: (e: any) => void;
    toDate: any;
    onToDateChange: (e: any) => void;
    selectedCustomer: ISelectViewModel;
    customers: ISelectViewModel[];
    onCustomerSelected: (e: any) => void;
    onlyUnsettledInvoices: boolean;
    onOnlyUnsettledInvoicesChange: (e: any) => void;
    onButtonClick: (e: any) => void;
    onFromDateBlur: (e: any) => void;
    onToDateBlur: (e: any) => void;
}

const ReceivableFilter = (props: IProps) => {
    return (
        <fieldset className="recivables-filter-form">
            <legend>{Translate('receivable/filter/legend')}</legend>
            <Row>
                <Col sm={12} md={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('receivable/filter/from-date-label')}
                        </ControlLabel>
                        <DateTime
                            locale={moment.locale()}
                            value={props.fromDate}
                            timeFormat={false}
                            onChange={props.onFromDateChange}
                            onBlur={props.onFromDateBlur}
                            isValidDate={(date) => {
                                return date.isSameOrBefore(props.toDate);
                            }}
                            closeOnSelect={true}
                        />
                    </FormGroup>
                </Col>
                <Col sm={12} md={6}>
                    <FormGroup>
                        <ControlLabel>{Translate('receivable/filter/to-date-label')}</ControlLabel>
                        <DateTime
                            locale={moment.locale()}
                            value={props.toDate}
                            timeFormat={false}
                            onChange={props.onToDateChange}
                            onBlur={props.onToDateBlur}
                            isValidDate={(date) => {
                                return date.isSameOrAfter(props.fromDate);
                            }}
                            closeOnSelect={true}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('receivable/filter/customer-select-label')}
                        </ControlLabel>
                        <Select
                            multi={false}
                            clearable={false}
                            placeholder={Translate('receivable/filter/customer-select/placeholder')}
                            noResultsText={Translate('receivable/filter/customer-select/no-result')}
                            value={props.selectedCustomer}
                            options={props.customers}
                            onChange={props.onCustomerSelected}
                        />
                    </FormGroup>
                </Col>

                <Col sm={12} md={6}>
                    <FormGroup>
                        <Checkbox
                            checked={props.onlyUnsettledInvoices}
                            onChange={props.onOnlyUnsettledInvoicesChange}
                            className="checkbox-margin"
                        >
                            <span>{Translate('receivable/filter/only-unsettled-invoices')}</span>
                        </Checkbox>
                    </FormGroup>
                </Col>
            </Row>
            <Button onClick={props.onButtonClick} bsStyle="primary">
                {Translate('receivable/filter/show')}
            </Button>
        </fieldset>
    );
};

export default ReceivableFilter;
